/**
 * we have to use this because ant d inserts a 0x0, display: flex, span before
 * the input when you select a value. Since the parent is a flex display, this
 * messes with the sizing and the span ends up being rendered with a non-zero
 * height and width
 *
 * i don't have an elegant css solution
 */
const JumpingSelectWorkaround: React.FC = ({ children }) => {
  return <div style={{ width: '100%', display: 'block' }}>{children}</div>
}

export default JumpingSelectWorkaround
